import { queryOptions, useQuery } from "@tanstack/react-query";

import type { QueryConfig } from "@/lib/react-query";
import { apiPaths } from "@/config/paths";
import { authApi } from "@/lib/api-client";

type McpClient = {
  /** The client_name the LLM client registered with, e.g. "Claude Code". */
  mcpClient: string | null;
  /** Where the client receives the authorization code, e.g. "https://claude.ai". */
  redirectOrigin: string | null;
  /** True for known AI apps, loopback and known app schemes; anything else gets the loud warning. */
  trustedRedirect: boolean;
};

/** Nulls (and untrusted) once the state ages out. */
const getMcpClient = (state: string): Promise<{ data: McpClient }> => {
  return authApi.get(apiPaths.auth.getMcpClient.getPath(), { params: { state } });
};

const getMcpClientQueryOptions = (state: string | null) => {
  return queryOptions({
    queryKey: ["mcp-client", state],
    queryFn: () => getMcpClient(state as string),
    enabled: Boolean(state),
    select: data => data.data,
    staleTime: Infinity,
  });
};

type UseMcpClientOptions = {
  queryConfig?: QueryConfig<typeof getMcpClientQueryOptions>;
};

export const useMcpClient = (state: string | null, { queryConfig }: UseMcpClientOptions = {}) => {
  return useQuery({
    ...getMcpClientQueryOptions(state),
    ...queryConfig,
  });
};
